package br.com.texeratx.boardgametimeapp.ui.screens.matches

import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI

data class MatchesUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
    val matches: List<MatchListItemUI> = emptyList(),
    val searchQuery: String = "",
    val filters: MatchesFilter = MatchesFilter(),
    val sort: MatchSortOption = MatchSortOption.DATE_DESC,
    val availableGames: List<MatchFilterGameOption> = emptyList(),
    val availablePlayers: List<MatchFilterPlayerOption> = emptyList()
)

data class MatchFilterGameOption(
    val id: Long,
    val name: String
)

data class MatchFilterPlayerOption(
    val id: Long,
    val name: String
)
